import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiClient";
import { useNavigate, useParams } from "react-router-dom";

const UserForm = ({ isEdit }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({
    email: "", phone_number: "", password: "", password_confirm: "",
    role: "surveyor", first_name: "", middle_name: "", last_name: "",
    organization: "", address_line_1: "", city: "", state: "", country: "", postal_code: ""
  });

  useEffect(() => {
    if (isEdit && id) {
      apiClient.get(`/auth/users/${id}/`).then((res) => setForm(res.data.data));
    }
  }, [isEdit, id]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(form).forEach((key) => formData.append(key, form[key]));

    if (isEdit) {
      await apiClient.put(`/auth/users/${id}/`, formData);
    } else {
      await apiClient.post("/auth/users/", formData);
    }
    navigate("/users");
  };

  return (
    <div className="user-form">
      <h1>{isEdit ? "Edit User" : "New User Creation"}</h1>
      <form onSubmit={handleSubmit}>
        {Object.keys(form).map((key) => (
          <div key={key}>
            <label>{key}</label>
            <input type="text" name={key} value={form[key]} onChange={handleChange} required={["email","password","password_confirm","first_name","last_name","address_line_1","city","state","country","postal_code"].includes(key)} />
          </div>
        ))}
        <button type="submit">{isEdit ? "Update" : "Create"} User</button>
      </form>
    </div>
  );
};

export default UserForm;
